// Features (produtos contratados) — consumido por hooks/features.js.
// Endpoint servido pelo backend_hub (PO1-1972) — usar `api` (API_URL), NÃO
// `ApiHubBackend` (API_HUB) que aponta pro hub-backend legado.
import api from "./api";

export async function fetchMyFeatures() {
  const response = await api.get("/features/me");
  return response.data?.features || [];
}
